'use strict';

require('../../user/UserService.js');
require('../../company/users/CompanyUserService.js');

function CompanyGuestUsersProfileCtrl(
  $scope,
  user,
  companyUserInfo,
  $stateParams,
  CompanyUserService,
  UserAvatarService,
  countryCode
) {
  $scope.user = user;
  $scope.companyUserInfo = companyUserInfo;
  $scope.profileType = $stateParams.type || null;
  $scope.countryCode = countryCode;

}

CompanyGuestUsersProfileCtrl.resolve = {
  user: ['$stateParams', 'UserService', function($stateParams, UserService) {
    return UserService.get({userId: $stateParams.userId}).$promise;
  }],
  companyUserInfo: ['CompanyUserService', '$stateParams', function(CompanyUserService, $stateParams){
    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $stateParams.userId}).$promise;
  }],
  countryCode: ['$http', function($http){
    return $http.get('country-code/country-code.json').then(function(resp){
      return resp.data;
    });
  }]
};
module.exports = CompanyGuestUsersProfileCtrl;

angular.module('dokiv')
  .controller('CompanyGuestUsersProfileCtrl', [
    '$scope',
    'user',
    'companyUserInfo',
    '$stateParams',
    'CompanyUserService',
    'UserAvatarService',
    'countryCode',
    CompanyGuestUsersProfileCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/users/CompanyGuestUsersProfileCtrl.js
// module id = 304
// module chunks = 0